export default class ArticleMediaTwoColumn {
  constructor(component) {
    this.refs = {
      link: '.js-link',
      containers: '.js-linkContainer',
    }
    this.dom = {
      $component: component,
      $containers: component.querySelectorAll(this.refs.containers),
    }
    this.state = {}
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.linkClickHandler()
  }

  linkClickHandler() {
    const { dom } = this
    dom.$containers.forEach(($container) => {
      $container.addEventListener('click', () => this.urlRedirect($container))
    })
  }

  urlRedirect(element) {
    const link = element.querySelector(this.refs.link)
    if (link) window.location.href = link.href
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ArticleMediaTwoColumn = this
  }
}
